module.exports = __webpack_public_path__ + "media/images/ear-speaker-c944dcb310d69c5e7081bf0356bc6bbf.svg";